import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface MerchantProfile {
  id?: string;
  name?: string;
  email?: string;
}

interface AuthState {
  token: string | null;
  merchant: MerchantProfile | null;
  isAuthenticated: boolean;
  setAuth: (token: string, merchant?: MerchantProfile) => void;
  setMerchant: (merchant: MerchantProfile) => void;
  logout: () => void;
}

/** Merchant auth store — token from client-credential exchange (/v1/auth/token). */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      merchant: null,
      isAuthenticated: false,
      setAuth: (token, merchant) => set({ token, merchant: merchant ?? null, isAuthenticated: true }),
      setMerchant: (merchant) => set({ merchant }),
      logout: () => set({ token: null, merchant: null, isAuthenticated: false }),
    }),
    { name: "aquapay-merchant-auth" }
  )
);
